import { ImageBuilder } from './image';
export const AUTO_TRADER_PUBLISHER = {
    '@type': 'Organization',
    name: 'Auto Trader',
    logo: {
        '@type': 'ImageObject',
        url: 'https://www.autotrader.co.uk/images/at3/autotrader.png',
        width: '372',
        height: '48',
    },
};
export class RatingBuilder {
    constructor(rating) {
        this.build = () => {
            return {
                '@type': 'Rating',
                ratingValue: this.rating,
                bestRating: this.bestRating || 5,
            };
        };
        this.rating = rating;
    }
    withRating(rating) {
        this.rating = rating;
        return this;
    }
    withBestRating(bestRating) {
        this.bestRating = bestRating;
        return this;
    }
}
RatingBuilder.aBuilder = (rating) => {
    return new RatingBuilder(rating);
};
export class ManufacturerBuilder {
    constructor(make) {
        this.withModelName = (model) => {
            this.model = model;
            return this;
        };
        this.build = () => ({
            '@type': 'Organization',
            name: this.make,
            model: this.model,
        });
        this.make = make;
    }
}
ManufacturerBuilder.aBuilder = (make) => {
    return new ManufacturerBuilder(make);
};
export class AuthorBuilder {
    constructor(author) {
        this.withAuthorImage = (url, width, height) => {
            this.image = ImageBuilder.aBuilder(url, width, height).build();
            return this;
        };
        this.build = () => ({
            '@type': 'Person',
            name: this.author,
            image: this.image,
        });
        this.author = author;
    }
}
AuthorBuilder.aBuilder = (author) => {
    return new AuthorBuilder(author);
};
export class VehicleBuilder {
    constructor(name, vehicleType) {
        this.withImage = (image) => {
            this.image = image;
            return this;
        };
        this.withRating = (rating) => {
            this.rating = RatingBuilder.aBuilder(rating).build();
            return this;
        };
        this.build = () => ({
            '@type': this.vehicleType,
            name: this.name,
            image: this.image,
            review: this.rating,
        });
        this.name = name;
        this.vehicleType = vehicleType || 'Car';
    }
}
VehicleBuilder.aBuilder = (name, vehicleType) => {
    return new VehicleBuilder(name, vehicleType);
};
export class CarBuilder extends VehicleBuilder {
    constructor(name) {
        super(name, 'Car');
    }
}
export class AggregateRatingBuilder {
    constructor(rating) {
        this.build = () => {
            return {
                '@type': 'AggregateRating',
                ratingValue: this.rating,
                bestRating: this.bestRating || 5,
                ratingCount: this.ratingCount,
                reviewCount: this.reviewCount,
            };
        };
        this.rating = rating;
    }
    withRating(rating) {
        this.rating = rating;
        return this;
    }
    withBestRating(bestRating) {
        this.bestRating = bestRating;
        return this;
    }
    withRatingCount(ratingCount) {
        this.ratingCount = ratingCount;
        return this;
    }
    withReviewCount(reviewCount) {
        this.reviewCount = reviewCount;
        return this;
    }
}
AggregateRatingBuilder.aBuilder = (rating) => {
    return new AggregateRatingBuilder(rating);
};
